export default __webpack_public_path__ + "static/media/paint_brush.34431b45.svg";